import React from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';

export default function PageFooter(props = {}) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" color="primary" sx={{ top: 'auto', bottom: 0 }}>
        <Toolbar sx={{ justifyContent: "center"}}>
          <div>© 2022 Copyright: Made with ❤️ by <a href="https://github.com/JohnDBR" target="_blank" rel="noreferrer" style={{color: "white"}}>John</a></div>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
